<page-loader *ngIf="!isDailyContentListLoaded"></page-loader>
<div class="details-top-section" *ngIf="isDailyContentListLoaded">
    <div class="app-l-container">
        <div class="app-l-page__navigation">
            <div class="app-l-page__previous" (click)="goBack()">
                <button
                    class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20">
                    <svg-icon icon="arrowLeft" class="w-100 h-100"></svg-icon>
                </button>
            </div>
            <div class="app-l-page__breadcrumbs">
                <ul class="breadcrumbs-list">
                    <li translate class="breadcrumbs-list-item">
                        <a [routerLink]="['/app/series']" translate
                            >series.title</a
                        >
                    </li>

                    <li
                        class="breadcrumbs-list-item app-l-current-page"
                        translate>
                        series.seriesTypes.daily
                    </li>
                </ul>
            </div>
        </div>
        <div class="app-l-details-banner" *ngIf="todaysDailyContent">
            <h1 translate>series.todaysDailyBoost</h1>
            <div class="series-type-past">
                <div
                    class="series-type-past_card card-today-daily-boost"
                    [ngStyle]="{ background: todaysDailyContent.lightColor }">
                    <div
                        class="series-type-past_card_content"
                        [ngStyle]="{ background: todaysDailyContent.bgColor }">
                        <span class="quote-mark"
                            ><img
                                src="./assets/img/icons-svg/quote-mark-right.svg"
                        /></span>
                        <p [ngStyle]="{ color: todaysDailyContent.textColor }">
                            {{ todaysDailyContent['text_' + lang] }}
                        </p>
                        <span class="quote-mark"
                            ><img
                                src="./assets/img/icons-svg/quote-mark-top.svg"
                        /></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="series-type-section" *ngIf="isDailyContentListLoaded">
    <span class="app-l-subTitle" translate>series.pastDailyContent</span>

    <div class="series-type-past">
        <ng-container *ngFor="let content of pastDailyContents">
            <div
                class="series-type-past_card"
                [ngStyle]="{ background: content.lightColor }">
                <div
                    class="series-type-past_card_content"
                    [ngStyle]="{ background: content.bgColor }">
                    <span
                        class="quote-mark"
                        [ngStyle]="{ color: content.darkColor }"
                        ><img src="./assets/img/icons-svg/quote-mark-top.svg"
                    /></span>
                    <p [ngStyle]="{ color: content.textColor }">
                        {{ content['text_' + lang] }}
                    </p>
                    <span
                        class="quote-mark"
                        [ngStyle]="{ color: content.darkColor }"
                        ><img src="./assets/img/icons-svg/quote-mark-right.svg"
                    /></span>
                </div>
            </div>
        </ng-container>
    </div>
    <ng-container *ngIf="pastDailyContents.length === 0">
        <div class="empty-card">
            <div class="app-dm-positive-cards" translate>series.noData</div>
        </div>
    </ng-container>
</div>
